import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';

const ForgotPassword = () => {
    const { post } = useApi();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');

        try {
            await post('/api/auth/password-reset/', { email });
            setMessage('If an account exists with this email, you will receive a password reset link shortly.');
        } catch (err) {
            console.error('Password reset request failed:', err);
            // Don't reveal if email exists or not for security, unless specifically required.
            // But usually we show the success message anyway, or a generic error.
            // For now, let's assume valid error handling.
            setMessage('If an account exists with this email, you will receive a password reset link shortly.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-indigo-900/10 border border-slate-100 p-10 max-w-md w-full">
                <div className="text-center mb-10">
                    <div className="h-16 w-16 bg-[#18216D]/5 rounded-2xl flex items-center justify-center mx-auto mb-6 text-[#18216D]">
                        <i className="fas fa-key text-2xl"></i>
                    </div>
                    <h2 className="text-2xl font-black text-[#18216D]">Forgot Credentials?</h2>
                    <p className="text-slate-400 font-bold text-sm mt-2">Enter your email to receive a recovery key.</p>
                </div>

                {message && (
                    <div className="mb-6 p-4 bg-emerald-50 border border-emerald-100 text-emerald-600 rounded-2xl text-sm font-bold flex items-center gap-3">
                        <i className="fas fa-check-circle"></i>
                        {message}
                    </div>
                )}

                {error && (
                    <div className="mb-6 p-4 bg-rose-50 border border-rose-100 text-rose-600 rounded-2xl text-sm font-bold flex items-center gap-3">
                        <i className="fas fa-circle-exclamation"></i>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 block mb-2 ml-1">Email Address</label>
                        <div className="relative">
                            <i className="far fa-envelope absolute left-5 top-1/2 -translate-y-1/2 text-slate-300"></i>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                disabled={loading}
                                className="w-full pl-14 pr-6 py-4 bg-slate-50 border-none rounded-2xl focus:ring-4 focus:ring-indigo-500/5 transition-all text-sm font-medium text-[#18216D] placeholder-slate-300"
                                placeholder="name@kianda.ac.ke"
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className={`w-full py-5 bg-[#18216D] text-white rounded-2xl font-black text-xs uppercase tracking-[0.2em] shadow-xl shadow-indigo-900/20 hover:bg-[#0D164F] hover:-translate-y-1 transition-all flex items-center justify-center gap-3 ${loading ? 'opacity-70 cursor-not-allowed' : ''}`}
                    >
                        {loading ? (
                            <>
                                <i className="fas fa-circle-notch fa-spin"></i>
                                Requesting...
                            </>
                        ) : (
                            <span>Send Recovery Key</span>
                        )}
                    </button>
                </form>

                <div className="mt-10 pt-10 border-t border-slate-50 text-center">
                    <Link to="/login" className="text-slate-400 font-bold text-sm hover:text-[#18216D] transition-colors flex items-center justify-center gap-2">
                        <i className="fas fa-arrow-left"></i>
                        Return to Sign In
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
